import { useDataProvider } from "@/providers/DataProvider";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./components/Sidebar";

export const Root = () => {
  const { categories } = useDataProvider();
  return (
    <div
      className="bg-light"
      style={{
        display: "flex",
        maxWidth: "100vw",
        minHeight: "100vh",
        width: "100vw",
      }}
    >
      <Sidebar style={{ width: "250px" }} categories={categories} />
      <main
        className="main py-5 px-4"
        style={{ marginLeft: "250px", flexGrow: 1 }}
      >
        <Outlet />
      </main>
    </div>
  );
};
